<template>
    <div class="complaint--layout">
        <div class="complaint--con">
            <div>
                <complaint-damage-form
                    v-if="form.type === 'damage'"
                    @submit="submitForm"
                    :disabled="disabled"
                    :can-edit-products="false"
                    :edit="true"
                    :admin="false"
                    :loading="loading"
                    :form="form"
                />
                <complaint-quality-form
                    v-else
                    @submit="submitForm"
                    :disabled="disabled"
                    :can-edit-products="false"
                    :edit="true"
                    :admin="false"
                    :loading="loading"
                    :form="form"
                />
            </div>

            <div>
                <complaint-files :files="{warranty_file: form.warranty_file, delivery_note_files: form.delivery_note_files, photo_of_dmg_files: form.photo_of_dmg_files}" />
            </div>
        </div>

        <notification></notification>
    </div>
</template>

<script>
import config from '../plugins/config.js'
import axios from 'axios';
import Vue from 'vue'
import {MdIcon} from 'vue-material/dist/components'
import Notification from '../components/Notification.vue'
import ComplaintDamageForm from '../components/ComplaintDamageForm.vue'
import ComplaintFiles from '../components/ComplaintFiles.vue'
import ComplaintQualityForm from "@/components/ComplaintQualityForm.vue";

Vue.use(MdIcon)

export default {
    name: 'ComplainEditForUser',

    components: {
        ComplaintQualityForm,
        Notification,
        ComplaintDamageForm,
        ComplaintFiles,
    },

    data() {
        return {
            loading: false,
            openConfirmationModal: false,
            form: {
                status: null,
                status_text: null,
                id: null,
                name: '',
                phone: '',
                email: '',
                buyer_name: '',
                zip: '',
                county: '',
                city: '',
                street: '',
                house_number: '',
                products: [],
                installation_status: 'before',
                installation_date: '',
                delivery_note_number: null,
                delivery_note_files: null,
                delivery_note_files_preview: null,
                photo_of_dmg_files: null,
                photo_of_dmg_files_preview: null,
                warranty_file: null,
                warranty_file_preview: null,
                message: ''
            }
        }
    },

    methods: {
        async submitForm() {
            try {
                this.loading = true;
                this.$store.commit('emptyValidation')

                let formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('uuid', this.form.uuid);
                formData.append('name', this.form.name);
                formData.append('phone', this.form.phone);
                formData.append('email', this.form.email);
                formData.append('buyer_name', this.form.buyer_name);
                formData.append('subject', this.form.subject);
                formData.append('county', this.form.county);
                formData.append('zip', this.form.zip);
                formData.append('city', this.form.city);
                formData.append('products', JSON.stringify(this.form.products));
                formData.append('street', this.form.street);
                formData.append('house_number', this.form.house_number);
                formData.append('delivery_note_number', this.form.delivery_note_number);
                formData.append('message', this.form.message);

                let url;
                if (this.form.type === 'damage') {
                    url = `complaints/${this.form.id}/update-damage`;
                } else {
                    url = `complaints/${this.form.id}/update-quality`;
                    formData.append('installation_status', this.form.installation_status);
                    formData.append('installation_date', this.form.installation_date);
                }

                if (this.form.delivery_note_files) {
                    this.form.delivery_note_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`delivery_note_files[${index}]`, file);
                        }
                    });
                }

                if (this.form.photo_of_dmg_files) {
                    this.form.photo_of_dmg_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`photo_of_dmg_files[${index}]`, file);
                        }
                    });
                }

                if (this.form.warranty_file) {
                    const file = Array.isArray(this.form.warranty_file) ? this.form.warranty_file[0] : this.form.warranty_file;
                    if (file instanceof File) {
                        formData.append(`warranty_file`, file);
                    }
                }

                formData.append('edit_by_user', true);

                const response = await axios.post(url, formData, config.AXIOS_DEFAULTS_WITH_FILE);
                this.$store.commit('setNotification', [response.message])
                await this.fetch();
                this.loading = false;

            } catch (error) {
                this.loading = false;
                console.error("Hiba:", error);

                if (error.errors) {
                    this.$store.commit('setValidation', error.errors);
                    this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                    return;
                }

                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        this.$store.commit('setValidation', error.response.data.errors);
                        this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                        return;
                    }

                    if (error.response.status === 413) {
                        this.$store.commit('setNotification', ['A feltöltött fájlok összmérete túl nagy! Próbáljon meg kevesebb vagy kisebb fájlt feltölteni.']);
                        return;
                    }

                    if (error.response.data && error.response.data.message) {
                        this.$store.commit('setNotification', [error.response.data.message]);
                        return;
                    }
                }

                this.$store.commit('setNotification', ['Váratlan hiba történt a mentés során.']);
            }
        },

        async fetch() {
            try {
                this.loading = true;
                const response = await axios.get(`/complaint/${this.$route.params.uuid}/fetch-for-user-edit`, config.AXIOS_DEFAULTS);

                this.form = {
                    id: response.id,
                    uuid: response.uuid,
                    type: response.type,
                    name: response.name,
                    status: response.status,
                    status_text: response.status_text,
                    phone: response.phone,
                    email: response.email,
                    buyer_name: response.buyer_name,
                    zip: response.zip,
                    county: response.county,
                    city: response.city,
                    street: response.street,
                    products: response.products,
                    house_number: response.house_number,
                    installation_status: response.installation_status,
                    installation_date: response.installation_date,
                    delivery_note_number: response.delivery_note_number ?? null,
                    delivery_note_files: response.delivery_note_files || null,
                    photo_of_dmg_files: response.photo_of_dmg_files || null,
                    warranty_file: response.warranty_file || null,
                    message: response.message,
                };
                this.loading = false;

            } catch (error) {
                console.error("Error fetching complaint:", error.response.status);
                this.loading = false;
                if (error.response && error.response.status === 404) {
                    this.$store.commit('setNotification', ['Reklamáció nem található!'])
                }
            }
        },
    },

    mounted() {
        this.fetch();
    },

    computed: {
        disabled() {
            return this.form.status === 'approved';
        }
    }
}
</script>

<style lang="scss">
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/layout/list-page.scss';
</style>